import React from "react";
import { useFormikContext } from "formik"; // Use the correct hook for Formik context
import styles from "./RecomendationPage.module.css";
import RadioButton from "../../Atoms/Inputs/RadioButtons/RadioButton";

const criteria = [
  {
    key: "intellectualAbility",
    label: "Intellectual Ability",
  },
  {
    key: "analyticalAbility",
    label: "Analytical Ability",
  },
  {
    key: "leadershipPotential",
    label: "Leadership Potential",
  },
  {
    key: "teamworkSkills",
    label: "Teamwork Skills",
  },
  {
    key: "planningSkills",
    label: "Planning Skills",
  },
  {
    key: "communicationSkills",
    label: "Communication Skill",
  },
  {
    key: "overall",
    label: "Overall",
  },
];

const ratings = [
  {
    value: 7,
    label: "Unable To Judge",
  },
  {
    value: 8,
    label: "Below Average",
  },
  {
    value: 9,
    label: "Average",
  },
  {
    value: 10,
    label: "Good",
  },
  {
    value: 11,
    label: "Very Good",
  },
  {
    value: 12,
    label: "Excellent",
  },
  {
    value: 13,
    label: "Outstanding",
  },
  {
    value: 14,
    label: "Exceptional",
  },
];

const RecomendationTable = () => {
  const { errors, touched, values, setFieldValue } = useFormikContext();

  const handleRatingChange = (criterion, ratingValue) => {
    setFieldValue(`${criterion}`, ratingValue);
  };


  return (
    <div className={styles["container"]}>
      <table className={styles["table-container"]}>
        <thead>
          <tr>
            <th></th>
            {ratings.map((rating) => (
              <th key={rating.value} className={styles.criteria}>
                {rating.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {criteria.map((criterion) => {
            return (
              <tr
                key={criterion.key}
                className={`${styles.rating} ${
                  errors?.[criterion.key] && touched?.[criterion.key]
                    ? styles["error-row"]
                    : ""
                } `}
              >
                <td
                  className={`${styles.rating} ${
                    errors?.[criterion.key] && touched?.[criterion.key]
                      ? styles["error-cell"]
                      : ""
                  }`}
                >
                  {criterion.label}
                </td>
                {ratings.map((rating) => {
                  return (
                    <td
                      key={rating.value}
                      style={{
                        textAlign: "center",
                        padding: "10px",
                      }}
                    >
                      {/* <input
                        type='radio'
                        name={`${criterion.key}`}
                        value={rating.value}
                        checked={values?.[criterion.key] === rating.value}
                        onChange={() =>
                          handleRatingChange(criterion.key, rating.value)
                        }
                      /> */}
                      <RadioButton
                        handleOnChange={() =>
                          handleRatingChange(criterion.key, rating.value)
                        }
                        value={rating.value}
                        checked={values?.[criterion.key] === rating.value}
                      />
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RecomendationTable;
